export const collection = {
    noData: '您还没有拥有任何 NFT。',
    title: '您的收藏',
};
